// src/utils/fetchUtils.js

export const fetchUtils = {
  get: async (url, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const res = await fetch(queryString ? `${url}?${queryString}` : url, {
      method: 'GET',
      credentials: 'include',  // automatically sends cookies (HTTP-only)
      headers: { 'Content-Type': 'application/json' },
    });
    return res.json();
  },

  post: async (url, body = {}, extraParams = {}) => {
  const queryString = new URLSearchParams(extraParams).toString();

  const isFormData = body instanceof FormData;

  const res = await fetch(queryString ? `${url}?${queryString}` : url, {
    method: "POST",
    credentials: "include",
    headers: isFormData ? {} : { "Content-Type": "application/json" },
    body: isFormData ? body : JSON.stringify(body),
  });

  return res.json();
},

  put: async (url, body = {}, extraParams = {}) => {
    const queryString = new URLSearchParams(extraParams).toString();
    const res = await fetch(queryString ? `${url}?${queryString}` : url, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    return res.json();
  },

  delete: async (url, extraParams = {}) => {
    const queryString = new URLSearchParams(extraParams).toString();
    const res = await fetch(queryString ? `${url}?${queryString}` : url, {
      method: 'DELETE',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    return res.json();
  },
};
